module.exports = __webpack_public_path__ + "img/equipment_login_img@3x.d3706181.png";